
import * as React from 'react';

type Segment = {
    value: number;
    color: string;
}

type PieRadialChartProps = {
    value: string,
    segments: Segment[],
    dim?: string,
    fontSize?: string,
    maxWidth?: string
}

export function RadialPieChart(props: PieRadialChartProps): JSX.Element {
    
    const safeDim = props.dim || '9rem';
    
    // Calculate total and cumulative offsets for each segment
    const total = props.segments.reduce((sum, seg) => sum + seg.value, 0);
    let cumulativeOffset = 0;
    
    const segmentPaths = props.segments.map((segment, index) => {
        const segmentPct = (segment.value / total) * 100;
        const offset = cumulativeOffset;
        cumulativeOffset += (segmentPct || 0);
        
        return (
            <path 
                key={index}
                style={{
                    stroke: segment.color,
                    fill: "none",
                    strokeWidth: "2.8",
                    //strokeLinecap: "round",
                    animation: "progress 1s ease-out"
                }}
                strokeDasharray={`${segmentPct}, 100`}
                strokeDashoffset={-offset}
                d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831" />
        );
    });

    return (
        <div style={{
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            width: safeDim,
            height: safeDim
        }}>
            <svg viewBox="0 0 36 36"
                style={{
                    display: "block",
                    margin: "auto auto",
                    maxWidth: props.maxWidth || "80%",
                    maxHeight: "250px"
                }}>

                {segmentPaths}

                <text x="18" y="18" dy="0.35em" style={{
                    fill: "#666",
                    fontSize: props.fontSize || "0.4em",
                    textAnchor: "middle"
                }}>
                    {props.value}
                </text>
            </svg>
        </div>
    );
}